import { render, staticRenderFns } from "./CouponDialog.vue?vue&type=template&id=4f2c974a&scoped=true"
import script from "./CouponDialog.vue?vue&type=script&lang=js"
export * from "./CouponDialog.vue?vue&type=script&lang=js"
import style0 from "./CouponDialog.vue?vue&type=style&index=0&id=4f2c974a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c974a",
  null
  
)

export default component.exports